import { configureStore, EnhancedStore } from '@reduxjs/toolkit'
import { AnyAction, CombinedState, PreloadedState } from 'redux'
import { createEpicMiddleware, EpicMiddleware, StateObservable } from 'redux-observable'
import { Observable } from 'rxjs'

import { rootEpic } from '../epic'
import { rootReducer, RootState } from '../reducer'

export function setupStore(
  preloadedState?: PreloadedState<RootState>
): EnhancedStore<
  CombinedState<RootState>,
  AnyAction,
  [EpicMiddleware<AnyAction, AnyAction, RootState>]
> {
  const epicMiddleware = createEpicMiddleware<AnyAction, AnyAction, RootState>()
  const store = configureStore({
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => [
      ...getDefaultMiddleware({ thunk: false }),
      epicMiddleware,
    ],
    preloadedState,
    reducer: rootReducer,
  })
  epicMiddleware.run((action$: Observable<AnyAction>, state$: StateObservable<RootState>) =>
    rootEpic(action$, state$)
  )

  return store
}

export const store = setupStore()

export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
